import React from "react";

const Section2 = ({url}) => {
  return (
    <section className="home-section-2">
      <div className="container">

        {/* Heading */}
        <div className="text-center section-header">
          <h2>
            Why Most Strategic Decisions Fail <br />
            <span>Before They Even Start</span>
          </h2>
        </div>

        <div className="row d-flex align-items-center justify-content-center">

          {/* Left Image */}
          <div className="col-lg-6 col-xl-5 col-md-12 image-col" >
            <div className="image-wrapper" data-aos="fade-right"
          data-aos-duration="1000">
             <img
                src={`${url}images/omnix/sec-2.png`}
                alt="meeting"
                className="img-fluid"
                />
            </div>
          </div>

          {/* Right Content */}
          <div className="col-lg-6 col-xl-5 col-md-12 content-col" data-aos="fade-left"
          data-aos-duration="1000">

              <div className="problem-card">

                <div className="icon-box">!</div>

                <div className="text">
                  <h5>The Loudest Voice Wins—Not the Best Idea</h5>
                  <p>
                    Your strategy gets shaped by whoever speaks more in the meeting. Critical assumptions go unchallenged, blind spots stay, and by then, it's too late to fix them.
                  </p>
                </div>

              </div>

              <div className="problem-card">

                <div className="icon-box">!</div>

                <div className="text">
                  <h5>Gathering Opinions Takes Weeks</h5>
                  <p>
                    You schedule the meeting. Wait for calendars to align. Hear conflicting advice. Schedule another meeting. Meanwhile, your competitor already moved—and your window closed.
                  </p>
                </div>

              </div>

              <div className="problem-card">

                <div className="icon-box">!</div>

                <div className="text">
                  <h5>No One Stress-Tests the Plan Until It Fails</h5>
                  <p>
                    Ideas that sound brilliant in the boardroom collapse under real-world pressure. Without a structured way to challenge assumptions before execution, you're betting millions on untested thinking.
                  </p>
                </div>

              </div>

          </div>

        </div>
      </div>
    </section>
  );
};

export default Section2;